var ModalMessageModule = /** @class */ (function () {
    function ModalMessageModule() {
    }
    return ModalMessageModule;
}());
export { ModalMessageModule };
